/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `web` - Web
 * * `action` - Action
 */
export enum AppTypeEnum {
    WEB = 'web',
    ACTION = 'action',
}
